import React, { useEffect, useRef, useState } from "react";
import PlusIcon from "../../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import Input from "../../../../components/Common/Input/Input";
import Button from "../../../../components/Common/Button/Button";
import UploadImageIcon from "../../../../components/Common/SvgIcons/CommonIcons/UploadImageIcon";
import { useForm, FormProvider, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import classes from "./CreatePoll.module.scss";
import { pollSchema } from "../../../../utils/mainTabs/social/createPoll";
import { mode } from "../../../../utils/formModes";
import {
  getPollByIdHandler,
  isPollExistHandler,
  postImageHandler,
  editPollHandler,
  copyPollHandler,
} from "../../../../store/actions/actionHandlers/socialActionHandler";
import { useLocation, useNavigate } from "react-router";
import InfoIcon from "../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import DeleteIcon from "../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import getTenantName from "../../../../utils/getTenantName";
import SelectThumbnailPopUp from "../../../../components/Common/SelectThumbnailPopUp/SelectThumbnailPopUp";
import { pollManagement } from "../../../../utils/mainTabs/social/pollManagement";
import { FormattedMessage } from "react-intl";

const CreatePollForm = ({
  formMode = mode.ADD,
  pollId,
  setisCopyModal,
  setisEditModal,
}) => {
  const [editPollData, seteditPollData] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitBtnDisable, setisSubmitBtnDisable] = useState(true);
  const [isPollExistError, setisPollExistError] = useState("");
  const [pollLoader, setPollLoader] = useState(false);
  const [isPollNameExistLoader, setIsPollNameExistLoader] = useState(false);
  const [isSselectThumbnailModal, setIsSselectThumbnailModal] = useState(false);
  const [thumbnailFileName, setThumbnailFileName] = useState("");
  const [optionLengthErrorMsg, setOptionLengthErrorMsg] = useState([]);
  const [isFeedbackMessageEnabled, setIsFeedbackMessageEnabled] =
    useState(false);
  const [isLearnerFeedbackEnabled, setIsLearnerFeedbackEnabled] =
    useState(false);
  const thumnailFileRef = useRef(null);
  const tenantName = getTenantName(dispatch, location);
  const methods = useForm({
    resolver: yupResolver(pollSchema),
    mode: "onBlur",
    defaultValues: {
      displayPollResult: true,
      isFeedbackMessageEnabled: false,
      isLearnerFeedbackEnabled: false,
      learnerFeedbackPlaceholder: "",
      optionList: [
        { option: "", optionImageUrl: {}, feedbackMessage: "" },
        { option: "", optionImageUrl: {}, feedbackMessage: "" },
      ],
    },
  });
  const {
    handleSubmit,
    formState: { isDirty },
    reset,
    setValue,
    getValues,
    watch,
    control,
  } = methods;
  const formData = watch([
    "pollQuestion",
    "thumbnailImageFile",
    "displayPollResult",
    "optionList",
  ]);
  const {
    fields: optionsState,
    append: appendOption,
    remove: removeOption,
    replace: replaceOption,
  } = useFieldArray({
    control,
    name: "optionList",
  });

  const onCrossIconClick = (index) => {
    if (optionsState.length > 2) {
      removeOption(index);
    } else {
      dispatch(
        setErrorHandler(errorTypes.WARN, "Minimum 2 options are required"),
      );
    }
  };

  const addNewClick = () => {
    if (optionsState.length <= 3) {
      setisSubmitBtnDisable(false);
      appendOption({ option: "", feedbackMessage: "" });
    } else {
      dispatch(
        setErrorHandler(errorTypes.WARN, "Maximum 4 options are allowed"),
      );
    }
  };

  const pollDataObjCreation = (
    displayPollResult,
    pollQuestion,
    pollDescription,
    option1,
    option2,
    option3,
    option4,
    feedbackMessage1,
    feedbackMessage2,
    feedbackMessage3,
    feedbackMessage4,
    isFeedbackMessageEnabled,
    isLearnerFeedbackEnabledVal = false,
    learnerFeedbackPlaceholder = "",
    pollImageUrl = "",
    optionImageUrl1 = "",
    optionImageUrl2 = "",
    optionImageUrl3 = "",
    optionImageUrl4 = "",
  ) => {
    // Build FeedbackMessages object dynamically with only non-empty values
    const feedbackMessages = {};
    if (feedbackMessage1 && feedbackMessage1.trim()) {
      feedbackMessages.FeedbackMessage1 = feedbackMessage1.trim();
    }
    if (feedbackMessage2 && feedbackMessage2.trim()) {
      feedbackMessages.FeedbackMessage2 = feedbackMessage2.trim();
    }
    if (feedbackMessage3 && feedbackMessage3.trim()) {
      feedbackMessages.FeedbackMessage3 = feedbackMessage3.trim();
    }
    if (feedbackMessage4 && feedbackMessage4.trim()) {
      feedbackMessages.FeedbackMessage4 = feedbackMessage4.trim();
    }

    let pollData = {
      Description: pollDescription,
      DisplayPollResult: displayPollResult,
      IsFeedbackMessageEnabled: isFeedbackMessageEnabled,
      IsLearnerFeedbackEnabled: isLearnerFeedbackEnabledVal,
      LearnerFeedbackPlaceholder: isLearnerFeedbackEnabledVal
        ? learnerFeedbackPlaceholder?.trim() || null
        : null,
      Name: pollQuestion,
      PollImageUrl: pollImageUrl,
      OptionImageUrls: {
        OptionImageUrl1: optionImageUrl1,
        OptionImageUrl2: optionImageUrl2,
        OptionImageUrl3: optionImageUrl3,
        OptionImageUrl4: optionImageUrl4,
      },
      Options: {
        Option1: option1,
        Option2: option2,
        Option3: option3,
        Option4: option4,
      },
      FeedbackMessages: feedbackMessages,
      VideoIds: "",
    };

    return pollData;
  };

  useEffect(() => {
    if (pollId)
      dispatch(getPollByIdHandler(pollId, new Date(), seteditPollData));
  }, [pollId, dispatch]);

  const onSubmit = (data) => {
    // Set loader immediately for all operations
    setPollLoader(true);

    const uniqueValues = new Set(
      data?.optionList?.map((v) => v?.option?.toLowerCase()?.trim()),
    );
    if (uniqueValues?.size < data?.optionList?.length) {
      setPollLoader(false); // Reset loader on validation error
      dispatch(
        setErrorHandler(errorTypes.WARN, "Poll options should be a unique."),
      );
    } else {
      const optionCheck = data?.optionList.map((item) => {
        if (!item?.optionImageUrl) {
          return false;
        } else if (Object.keys(item?.optionImageUrl).length === 0) return false;
        else return true;
      });
      //   const errorMsg = "";
      //   const errorMsg = data?.optionList?.map((item) => {
      //     if (
      //       item?.option?.length > 12 &&
      //       item?.optionImageUrl &&
      //       Object.keys(item?.optionImageUrl).length
      //     )
      //       return "Only 12 characters are allowed option with image";
      //     else return "";
      //   });
      if (
        new Set(optionCheck).size === 1
        // && errorMsg.every((element) => element === "")
      ) {
        // Determine thumbnail image for edit/copy mode BEFORE pollDataObjCreation
        let thumbnailImage;
        let pollImageUrl = ""; // For pollDataObjCreation

        if (formMode === mode.EDIT || formMode === mode.COPY) {
          if (data?.thumbnailImageFile?.[0]) {
            // User uploaded a new thumbnail (File object)
            // This will trigger: postImage API → get blob URL → editPoll API with blob URL
            thumbnailImage = data.thumbnailImageFile[0];
            pollImageUrl = ""; // Will be set by postImageHandler
          } else if (editPollData?.PollImageUrl && thumbnailFileName) {
            // User kept existing thumbnail (URL string)
            // This will directly use existing URL in editPoll API (no postImage call)
            thumbnailImage = editPollData.PollImageUrl;
            pollImageUrl = editPollData.PollImageUrl; // Set existing URL
          } else {
            // No thumbnail available
            thumbnailImage = null;
            pollImageUrl = "";
          }
        }

        // Determine option image URLs based on mode
        let optionImageUrl1 = "",
          optionImageUrl2 = "",
          optionImageUrl3 = "",
          optionImageUrl4 = "";

        if (formMode === mode.EDIT || formMode === mode.COPY) {
          // For each option, check if there's a new file upload or use existing URL
          const optionImageUrls = [
            {
              current: data?.optionList[0]?.optionImageUrl,
              existing: editPollData?.OptionImageUrls?.OptionImageUrl1,
            },
            {
              current: data?.optionList[1]?.optionImageUrl,
              existing: editPollData?.OptionImageUrls?.OptionImageUrl2,
            },
            {
              current: data?.optionList[2]?.optionImageUrl,
              existing: editPollData?.OptionImageUrls?.OptionImageUrl3,
            },
            {
              current: data?.optionList[3]?.optionImageUrl,
              existing: editPollData?.OptionImageUrls?.OptionImageUrl4,
            },
          ];

          [optionImageUrl1, optionImageUrl2, optionImageUrl3, optionImageUrl4] =
            optionImageUrls.map(({ current, existing }) => {
              if (current instanceof FileList && current.length > 0) {
                // New file upload - will be handled by postImageHandler
                return "";
              } else if (typeof current === "string" && current) {
                // Existing URL (already processed by postImageHandler in previous save)
                return current;
              } else if (existing) {
                // Keep existing URL from original poll data
                return existing;
              }
              return "";
            });
        }
        // For ADD mode, option image URLs remain empty strings since they'll be set by postImageHandler

        console.log("=== OPTION IMAGE URLs DEBUGGING ===");
        console.log("formMode:", formMode);
        console.log("optionImageUrl1:", optionImageUrl1);
        console.log("optionImageUrl2:", optionImageUrl2);
        console.log("optionImageUrl3:", optionImageUrl3);
        console.log("optionImageUrl4:", optionImageUrl4);
        console.log(
          "editPollData?.OptionImageUrls:",
          editPollData?.OptionImageUrls,
        );
        console.log(
          "data?.optionList:",
          data?.optionList?.map((opt, i) => ({
            [`option${i + 1}`]: opt?.option,
            [`optionImageUrl${i + 1}`]: opt?.optionImageUrl,
          })),
        );

        const pollData = pollDataObjCreation(
          data?.displayPollResult,
          data?.pollQuestion,
          data?.pollDescription,
          data?.optionList[0]?.option,
          data?.optionList[1]?.option,
          data?.optionList[2]?.option,
          data?.optionList[3]?.option,
          data?.optionList[0]?.feedbackMessage,
          data?.optionList[1]?.feedbackMessage,
          data?.optionList[2]?.feedbackMessage,
          data?.optionList[3]?.feedbackMessage,
          isFeedbackMessageEnabled,
          isLearnerFeedbackEnabled,
          data?.learnerFeedbackPlaceholder || "",
          pollImageUrl, // Use determined pollImageUrl
          optionImageUrl1,
          optionImageUrl2,
          optionImageUrl3,
          optionImageUrl4,
        );
        if (formMode === mode.EDIT || formMode === mode.COPY) {
          const editedPollData = { ...pollData, PollId: pollId };

          // Check if thumbnail file contains actual file data
          const hasThumbnailFileData = thumbnailImage instanceof File;
          console.log("=== EDIT/COPY DEBUGGING ===");
          console.log("thumbnailImage:", thumbnailImage);
          console.log("thumbnailImage type:", typeof thumbnailImage);
          console.log(
            "thumbnailImage instanceof File:",
            thumbnailImage instanceof File,
          );
          console.log("hasThumbnailFileData:", hasThumbnailFileData);
          console.log("data.thumbnailImageFile:", data?.thumbnailImageFile);
          console.log("editPollData.PollImageUrl:", editPollData?.PollImageUrl);
          console.log("thumbnailFileName:", thumbnailFileName);

          // Check if any option images have file data
          const hasOptionImageFiles = data?.optionList.some((option) => {
            const hasFileData =
              option?.optionImageUrl &&
              option.optionImageUrl instanceof FileList &&
              option.optionImageUrl.length > 0;
            console.log(
              "Option hasFileData:",
              hasFileData,
              option?.optionImageUrl,
            );
            return hasFileData;
          });

          console.log("hasOptionImageFiles:", hasOptionImageFiles);

          if (hasThumbnailFileData || hasOptionImageFiles) {
            console.log(
              "📤 CALLING postImageHandler - NEW FILE UPLOADS DETECTED",
            );
            console.log("editedPollData:", editedPollData);
            console.log("hasThumbnailFileData:", hasThumbnailFileData);
            console.log("hasOptionImageFiles:", hasOptionImageFiles);
            console.log("thumbnailImage (for imageData[0]):", thumbnailImage);

            // Call postImage API first for new uploads, then edit/copy poll API
            const imageData = [
              thumbnailImage, // File object (new upload) or URL string (existing) or null
              data?.optionList[0]?.optionImageUrl,
              data?.optionList[1]?.optionImageUrl,
              data?.optionList[2]?.optionImageUrl,
              data?.optionList[3]?.optionImageUrl,
            ];

            console.log("📦 imageData array:", imageData);

            dispatch(
              postImageHandler(
                imageData,
                editedPollData,
                navigate,
                formMode === mode.EDIT ? mode.EDIT : mode.COPY,
                editedPollData.Name,
                tenantName,
                setPollLoader,
              ),
            );
          } else {
            console.log("⚡ DIRECT API CALL - NO NEW FILE UPLOADS");
            console.log("editedPollData:", editedPollData);
            if (formMode === mode.EDIT) {
              dispatch(
                editPollHandler(
                  editedPollData,
                  editedPollData.Name,
                  setPollLoader,
                ),
              );
            } else {
              dispatch(
                copyPollHandler(
                  editedPollData,
                  navigate,
                  editedPollData.Name,
                  tenantName,
                  setPollLoader,
                ),
              );
            }
          }
        } else {
          const imageData = [
            data?.thumbnailImageFile?.[0],
            data?.optionList[0]?.optionImageUrl?.[0],
            data?.optionList[1]?.optionImageUrl?.[0],
            data?.optionList[2]?.optionImageUrl?.[0],
            data?.optionList[3]?.optionImageUrl?.[0],
          ];
          dispatch(
            postImageHandler(
              imageData,
              pollData,
              navigate,
              mode.ADD,
              data?.pollQuestion,
              tenantName,
              setPollLoader,
            ),
          );
        }
      } else if (new Set(optionCheck).size !== 1) {
        setPollLoader(false); // Reset loader on validation error
        dispatch(
          setErrorHandler(
            errorTypes.WARN,
            "All answer options should either be only Text Or Text With Image",
          ),
        );
      }
    }
  };

  const imgeExtensionCheck = (event, name) => {
    let files = event.target.files[0];
    const fileSize = files.size / 1024 / 1024;
    const accept = ["image/png", "image/jpeg", "image/gif", "image/bmp"];
    if (!accept.includes(files.type)) {
      setValue(name, "");
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Please select a valid format from [.png, .jpg, .gif, .bmp]",
        ),
      );
    } else if (accept.includes(files.type) && fileSize > 10) {
      setValue(name, "");
      setThumbnailFileName("");
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Selected ['png', 'jpg', 'gif', 'bmp', 'jpeg'] Size must not exceed 10MB",
        ),
      );
    }
  };

  const fileChange = (event, name) => {
    event.preventDefault();
    imgeExtensionCheck(event, name);
    optionChange();
  };

  useEffect(() => {
    if (pollId === 0) {
      reset();
      setIsFeedbackMessageEnabled(false); // Initialize master checkbox state
      setIsLearnerFeedbackEnabled(false);
    }
    if (editPollData && Object.keys(editPollData).length > 0) {
      console.log("=== EDIT POLL DATA DEBUGGING ===");
      console.log("editPollData:", editPollData);
      console.log("editPollData.Options:", editPollData?.Options);
      console.log(
        "editPollData.OptionImageUrls:",
        editPollData?.OptionImageUrls,
      );
      console.log(
        "editPollData.FeedbackMessages:",
        editPollData?.FeedbackMessages,
      );

      reset();
      setValue("displayPollResult", editPollData?.DisplayPollResult);
      setValue(
        "pollQuestion",
        formMode === mode.COPY
          ? editPollData?.Question + "_Copy"
          : editPollData?.Question,
      );
      setValue("pollDescription", editPollData?.Description);
      setValue(
        "isFeedbackMessageEnabled",
        editPollData?.IsFeedbackMessageEnabled || false,
      );

      // Set thumbnail image if exists
      if (editPollData?.PollImageUrl) {
        setThumbnailFileName("File");
      }

      // Handle both possible API response formats
      let option1, option2, option3, option4;
      let optionImageUrl1, optionImageUrl2, optionImageUrl3, optionImageUrl4;
      let feedbackMessage1,
        feedbackMessage2,
        feedbackMessage3,
        feedbackMessage4;

      // Check if Options is an object with properties or an array
      if (editPollData?.Options?.Option1 !== undefined) {
        // Object format (Option1, Option2, etc.)
        option1 = editPollData.Options.Option1;
        option2 = editPollData.Options.Option2;
        option3 = editPollData.Options.Option3;
        option4 = editPollData.Options.Option4;

        optionImageUrl1 = editPollData?.OptionImageUrls?.OptionImageUrl1;
        optionImageUrl2 = editPollData?.OptionImageUrls?.OptionImageUrl2;
        optionImageUrl3 = editPollData?.OptionImageUrls?.OptionImageUrl3;
        optionImageUrl4 = editPollData?.OptionImageUrls?.OptionImageUrl4;

        feedbackMessage1 = editPollData?.FeedbackMessages?.FeedbackMessage1;
        feedbackMessage2 = editPollData?.FeedbackMessages?.FeedbackMessage2;
        feedbackMessage3 = editPollData?.FeedbackMessages?.FeedbackMessage3;
        feedbackMessage4 = editPollData?.FeedbackMessages?.FeedbackMessage4;
      } else if (Array.isArray(editPollData?.Options)) {
        // Array format ([0], [1], etc.)
        option1 = editPollData.Options[0];
        option2 = editPollData.Options[1];
        option3 = editPollData.Options[2];
        option4 = editPollData.Options[3];

        optionImageUrl1 = editPollData?.OptionImageUrls?.[0];
        optionImageUrl2 = editPollData?.OptionImageUrls?.[1];
        optionImageUrl3 = editPollData?.OptionImageUrls?.[2];
        optionImageUrl4 = editPollData?.OptionImageUrls?.[3];

        feedbackMessage1 = editPollData?.FeedbackMessages?.[0];
        feedbackMessage2 = editPollData?.FeedbackMessages?.[1];
        feedbackMessage3 = editPollData?.FeedbackMessages?.[2];
        feedbackMessage4 = editPollData?.FeedbackMessages?.[3];
      }

      console.log("=== PROCESSED OPTIONS ===");
      console.log(
        "option1:",
        option1,
        "option2:",
        option2,
        "option3:",
        option3,
        "option4:",
        option4,
      );
      console.log(
        "optionImageUrl1:",
        optionImageUrl1,
        "optionImageUrl2:",
        optionImageUrl2,
      );
      console.log(
        "feedbackMessage1:",
        feedbackMessage1,
        "feedbackMessage2:",
        feedbackMessage2,
      );

      replaceOption([
        {
          option: option1,
          optionImageUrl: optionImageUrl1,
          feedbackMessage: feedbackMessage1 || "",
        },
        {
          option: option2,
          optionImageUrl: optionImageUrl2,
          feedbackMessage: feedbackMessage2 || "",
        },
      ]);

      if (option3) {
        appendOption({
          option: option3,
          optionImageUrl: optionImageUrl3,
          feedbackMessage: feedbackMessage3 || "",
        });
      }
      if (option4) {
        appendOption({
          option: option4,
          optionImageUrl: optionImageUrl4,
          feedbackMessage: feedbackMessage4 || "",
        });
      }

      // Set feedback message enabled state from API response
      setIsFeedbackMessageEnabled(
        editPollData?.IsFeedbackMessageEnabled || false,
      );

      // Set learner feedback enabled state from API response
      const learnerFeedbackEnabledVal =
        editPollData?.IsLearnerFeedbackEnabled || false;
      setValue("isLearnerFeedbackEnabled", learnerFeedbackEnabledVal);
      setValue(
        "learnerFeedbackPlaceholder",
        editPollData?.LearnerFeedbackPlaceholder ||
          ((formMode === mode.EDIT || formMode === mode.COPY) &&
          learnerFeedbackEnabledVal
            ? "Tell us more"
            : ""),
      );
      setIsLearnerFeedbackEnabled(learnerFeedbackEnabledVal);
    }
  }, [
    editPollData,
    setValue,
    pollId,
    reset,
    replaceOption,
    appendOption,
    formMode,
  ]);

  const formChange = () => {
    const pollData = getValues();
    const option1 = pollData?.optionList?.[0]?.option?.trim();
    const option2 = pollData?.optionList?.[1]?.option?.trim();
    const option3 = pollData?.optionList?.[2]?.option?.trim();
    const option4 = pollData?.optionList?.[3]?.option?.trim();

    // Check thumbnail validation for edit/copy modes
    const hasThumbnail =
      formMode === mode.EDIT || formMode === mode.COPY
        ? pollData?.thumbnailImageFile ||
          (editPollData?.PollImageUrl && thumbnailFileName)
        : true; // For ADD mode, thumbnail is handled separately

    if (
      option1 &&
      option2 &&
      !isPollExistError &&
      hasThumbnail &&
      pollData?.optionList?.length === 2
    ) {
      setisSubmitBtnDisable(true);
    } else if (
      option1 &&
      option2 &&
      option3 &&
      !isPollExistError &&
      hasThumbnail &&
      pollData?.optionList?.length === 3
    ) {
      setisSubmitBtnDisable(true);
    } else if (
      option1 &&
      option2 &&
      option3 &&
      option4 &&
      !isPollExistError &&
      hasThumbnail &&
      pollData?.optionList?.length === 4
    ) {
      setisSubmitBtnDisable(true);
    } else if (
      (!option1 || !option2 || isPollExistError || !hasThumbnail) &&
      pollData?.optionList?.length === 2
    ) {
      setisSubmitBtnDisable(false);
    } else if (
      (!option1 || !option2 || !option3 || isPollExistError || !hasThumbnail) &&
      pollData?.optionList?.length === 3
    ) {
      setisSubmitBtnDisable(false);
    } else if (
      (!option1 ||
        !option2 ||
        !option3 ||
        !option4 ||
        isPollExistError ||
        !hasThumbnail) &&
      pollData?.optionList?.length === 4
    ) {
      setisSubmitBtnDisable(false);
    } else {
      setisSubmitBtnDisable(true);
    }
  };

  useEffect(() => {
    if (isPollExistError) {
      setisSubmitBtnDisable(false);
    } else {
      setisSubmitBtnDisable(true);
    }
  }, [isPollExistError]);

  // Trigger form validation when thumbnail filename changes (file removed/added)
  useEffect(() => {
    formChange();
  }, [thumbnailFileName]);

  const pollQuestionChange = (e) => {
    if (e.target.value) {
      if (formMode === mode.ADD || formMode === mode.COPY) {
        dispatch(
          isPollExistHandler(
            0,
            e.target.value,
            setisPollExistError,
            setIsPollNameExistLoader,
          ),
        );
      }
    }
  };

  const resetForm = () => {
    reset();
    setThumbnailFileName("");
    setOptionLengthErrorMsg([]);
    setIsFeedbackMessageEnabled(false); // Reset master checkbox state
    setIsLearnerFeedbackEnabled(false);
    if (optionsState.length === 3) {
      appendOption({ option: "", feedbackMessage: "" });
    }
    if (optionsState.length === 4) {
      appendOption({ option: "", feedbackMessage: "" });
      appendOption({ option: "", feedbackMessage: "" });
    }
  };

  const toggleLearnerFeedback = () => {
    setIsLearnerFeedbackEnabled((prev) => {
      const newState = !prev;
      if (!newState) {
        setValue("learnerFeedbackPlaceholder", "");
      }
      return newState;
    });
  };

  const toggleFeedbackMessages = () => {
    setIsFeedbackMessageEnabled((prev) => {
      const newState = !prev;
      // Clear all feedback messages when disabling
      if (!newState) {
        optionsState.forEach((_, index) => {
          setValue(`optionList[${index}].feedbackMessage`, "");
        });
      }
      return newState;
    });
  };

  const optionChange = () => {
    // const optionList = getValues("optionList");
    // const errorMsg = optionList?.map((item) => {
    //   if (
    //     item?.option?.length > 12 &&
    //     item?.optionImageUrl &&
    //     Object.keys(item?.optionImageUrl)?.length
    //   )
    //     return "Only 12 characters are allowed option with image";
    //   else return "";
    // });
    // setOptionLengthErrorMsg(errorMsg);
  };

  const okBtnClick = () => {
    thumnailFileRef?.current?.click();
  };

  return (
    <FormProvider {...methods}>
      {formMode === mode.ADD && (
        <div className={classes.createNewPollHeaing}>
          <p> Add New Poll Details</p>
        </div>
      )}
      <form
        onSubmit={handleSubmit(onSubmit)}
        onChange={formChange}
        className={classes.pollForm}
      >
        <div
          className={`${classes.createNewPoll}${formMode !== mode.ADD ? ` ${classes.createNewPollScroll}` : ""}`}
        >
          <div className={classes.newPollPage}>
            <Input
              label={"Display Poll results to the user :"}
              name="displayPollResult"
              fieldName="displayPollResult"
              type="checkbox"
              labelColor="dark"
              direction="row"
              width="2"
              height="2"
            />
            <Input
              label="Poll Question"
              name="pollQuestion"
              placeholder="Enter Poll Question"
              labelColor="dark"
              width="46.4"
              labelMsg="(Max: 200 Characters)"
              required
              onBlur={pollQuestionChange}
              error={isPollExistError ? isPollExistError : ""}
              maxLength="200"
              loading={isPollNameExistLoader}
            />
            <Input
              label="Poll Description"
              name="pollDescription"
              placeholder="Enter Poll Description"
              labelColor="dark"
              width="46.4"
              labelMsg="(Max: 500 Characters)"
              maxLength="500"
              type="textarea"
            />
            {/* {formMode === mode.ADD && ( */}
            <div className={classes.uploadThumbnailBtn}>
              <Input
                label="Upload Poll Thumbnail"
                name="thumbnailImageFile"
                labelColor="dark"
                hidden
                type="file"
                required
                accept=".png, .jpg, .gif, .bmp"
                width="21"
                disableLabelClick={"true"}
                handleClickFileButton={() => setIsSselectThumbnailModal(true)}
                fileInputName={thumbnailFileName}
                handleCancelFileInput={() => setThumbnailFileName("")}
              />
              <div className={classes.infoIcon}>
                <Tooltip
                  direction="right"
                  content="Format Supported: .png, .jpg, .gif, .bmp"
                >
                  <InfoIcon />
                </Tooltip>
              </div>
            </div>
            {/* )} */}
            <Input
              label="Allow Learners to add Feedback"
              name="isLearnerFeedbackEnabled"
              type="checkbox"
              labelColor="dark"
              direction="row"
              width="2"
              height="2"
              checked={isLearnerFeedbackEnabled}
              onChange={toggleLearnerFeedback}
            />
            {isLearnerFeedbackEnabled && (
              <Input
                label="Learner Feedback Label"
                name="learnerFeedbackPlaceholder"
                placeholder="Enter Learner Feedback Label"
                labelColor="dark"
                width="46.4"
                maxLength="25"
                labelMsg="(Max: 25 Characters)"
              />
            )}
          </div>

          <div className={classes.newPollPage}>
            {/* Master Feedback Message Checkbox */}

            <Input
              label="Enable Feedback Messages for All Options"
              name="enableFeedbackMessages"
              type="checkbox"
              labelColor="dark"
              direction="row"
              width="2"
              height="2"
              checked={isFeedbackMessageEnabled}
              onChange={toggleFeedbackMessages}
            />

            {optionsState?.map((data, index) => {
              return (
                <div key={data.id}>
                  <div className={classes.options}>
                    <Input
                      label={`Option - ${index + 1}`}
                      name={`optionList[${index}].option`}
                      placeholder={`Enter Option${index + 1}`}
                      labelColor="dark"
                      required
                      width="35"
                      maxLength="100"
                      onChange={optionChange}
                      labelMsg={`(Max: ${
                        formData?.[3]?.[index]?.optionImageUrl &&
                        Object.keys(formData?.[3]?.[index]?.optionImageUrl)
                          ?.length
                          ? "100"
                          : "100"
                      } Characters)`}
                    />
                    <div className={classes.optionLengthErrorMsg}>
                      {optionLengthErrorMsg[index]}
                    </div>
                    <div className={classes.uploadImage}>
                      {/* Add Image Label */}
                      <div className={classes.addImageLabel}>
                        <label className={classes.labelText}>Add Image</label>
                      </div>

                      {/* Add Image Input */}
                      <div className={classes.addImageInput}>
                        <div className={classes.btn}>
                          <Input
                            name={`optionList[${index}].optionImageUrl`}
                            labelColor="dark"
                            hidden
                            type="file"
                            reference={data.ref}
                            fileInputIcon={UploadImageIcon}
                            accept=".png, .jpg, .gif, .bmp"
                            onChange={(event) =>
                              fileChange(
                                event,
                                `optionList[${index}].optionImageUrl`,
                              )
                            }
                            width={10}
                            fileInputButtonWidth={7}
                            placeholder=" "
                            handleCancelFileInput={() => optionChange()}
                          />
                        </div>
                      </div>

                      {/* Delete Icon */}
                      <div className={classes.deleteIcon}>
                        <div
                          onClick={() => {
                            onCrossIconClick(index);
                            optionChange();
                            formChange();
                          }}
                          className={classes.crossIcon}
                        >
                          <Tooltip direction="left" content="Remove Option">
                            <DeleteIcon />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Feedback Message Input - shows when master checkbox is checked */}
                  {isFeedbackMessageEnabled && (
                    <div className={classes.feedbackMessageInput}>
                      <Input
                        label={`Feedback Message for Option ${index + 1}`}
                        name={`optionList[${index}].feedbackMessage`}
                        placeholder={`Enter Feedback Message for Option ${index + 1}`}
                        labelColor="dark"
                        width="44"
                        maxLength="500"
                        labelMsg="(Max: 500 Characters)"
                        type="textarea"
                      />
                      {/* Horizontal separator line */}
                      {index < optionsState.length - 1 && (
                        <div className={classes.optionSeparator}></div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
            <Button
              label="Add New"
              width="10.3"
              height="2.8"
              borderRadius="0.7"
              light
              icon={PlusIcon}
              onClick={addNewClick}
            />
          </div>
        </div>
        <div className={classes.footer}>
          <p className={classes.manadatoryText}>* Indicates mandatory fields</p>
          <div className={classes.formBtn}>
            {!isDirty && (
              <span
                className={classes.cancelText}
                onClick={() => {
                  if (formMode === mode.ADD)
                    navigate(pollManagement.path(tenantName));
                  else if (formMode === mode.EDIT) setisEditModal(false);
                  else setisCopyModal(false);
                }}
              >
                <FormattedMessage id="CANCEL_TEXT" />
              </span>
            )}
            {isDirty && (
              <span className={classes.cancelText} onClick={resetForm}>
                <FormattedMessage id="CLEAR_ALL_TXT" />
              </span>
            )}

            <Button
              type="submit"
              label={<FormattedMessage id="SAVE_TXT" />}
              small
              dark
              backgroundColor={pollLoader ? undefined : "#D31B61"}
              loading={pollLoader}
              disabled={
                (formMode === mode.ADD &&
                  formData[0] &&
                  formData[1] &&
                  isSubmitBtnDisable) ||
                ((formMode === mode.EDIT || formMode === mode.COPY) &&
                  formData[0] &&
                  isSubmitBtnDisable)
                  ? false
                  : true
              }
            />
          </div>
        </div>
      </form>
      <SelectThumbnailPopUp
        isOpenModal={isSselectThumbnailModal}
        setIsOpenModal={setIsSselectThumbnailModal}
        fileRef={thumnailFileRef}
        setValue={setValue}
        setThumbnailFileName={setThumbnailFileName}
        okBtnClick={okBtnClick}
      />
    </FormProvider>
  );
};

export default CreatePollForm;
